import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import AnalyticsTracker from "components/AnalyticsTracker";
import { AuthProvider } from "./contexts/AuthContext";
// Add your imports here
import Homepage from "pages/homepage";
import CategoryBrowse from "pages/category-browse";
import BrowseCategoriesAllVendorTypes from "pages/browse-categories-all-vendor-types";
import AllVendors from "pages/all-vendors";
import VendorRegistration from "pages/vendor-registration";
import VendorProfile from "pages/vendor-profile";
import UserDashboard from "pages/user-dashboard";
import UserDashboardWeddingPlanningTools from "pages/user-dashboard-wedding-planning-tools";
import VendorDashboard from "pages/vendor-dashboard";
import AdminDashboard from "pages/admin-dashboard";
import DesignSystemUpdate from "pages/design-system-update";
import UserDashboardCleanMobileLayout from "pages/user-dashboard-clean-mobile-layout";
import NotFound from "pages/NotFound";
import Login from "components/auth/Login";
import Signup from "components/auth/Signup";
import SignUpPage from "pages/sign-up-page";
import SignInPage from "pages/sign-in-page";
import AboutUs from "pages/about-us";
import ContactUs from "pages/contact-us";
import HelpCenter from "pages/help-center";
import TermsOfService from "pages/terms-of-service";
import PrivacyPolicy from "pages/privacy-policy";
import PlanningTools from "pages/planning-tools";
import Careers from "pages/careers";
import SiteMap from "pages/sitemap";
import MessageDetail from "pages/message-detail";
import EventDetail from "pages/event-detail";
import ReferralHistory from "pages/referral-history";
import Notifications from "pages/notifications";
import AuthCallback from "pages/AuthCallback";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <AnalyticsTracker />
          <RouterRoutes>
            {/* Define your routes here */}
            <Route path="/" element={<Homepage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/homepage" element={<Homepage />} />
            <Route path="/category-browse" element={<CategoryBrowse />} />
            <Route path="/browse-categories-all-vendor-types" element={<BrowseCategoriesAllVendorTypes />} />
            <Route path="/all-vendors" element={<AllVendors />} />
            <Route path="/vendor-registration" element={<VendorRegistration />} />
            <Route path="/vendor-profile" element={<VendorProfile />} />
            <Route path="/vendor-profile/:vendorId" element={<VendorProfile />} />
            <Route path="/user-dashboard" element={<UserDashboard />} />
            <Route path="/user-dashboard-wedding-planning-tools" element={<UserDashboardWeddingPlanningTools />} />
            <Route path="/user-dashboard-clean-mobile-layout" element={<UserDashboardCleanMobileLayout />} />
            <Route path="/vendor-dashboard" element={<VendorDashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/design-system-update" element={<DesignSystemUpdate />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/help-center" element={<HelpCenter />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/planning-tools" element={<PlanningTools />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/sitemap" element={<SiteMap />} />
            <Route path="/message-detail" element={<MessageDetail />} />
            <Route path="/event-detail" element={<EventDetail />} />
            <Route path="/referral-history" element={<ReferralHistory />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/sign-up-page" element={<SignUpPage />} />
            <Route path="/sign-in-page" element={<SignInPage />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;